import React, { useEffect, useState } from "react";
import { Button, Pagination, Spin } from "antd";
import { StyledIncomeHistoryModal } from "./style";

import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../store/config";
import { PaginationType } from "../../interfaces/screens/fetch-params-types";
import { PAGE_SIZE } from "../../common/config";
import { StyledTable } from "../../components/common/styles/tableStyles";
import { useParams } from "react-router-dom";
import { formatNumber, getCurrencySymbol } from "../../utils/utils";
import {
  getRevenuesStart,
  resetIncomeHistory,
} from "../../store/features/dashboard/revenues/revenues-slice";
import { monthsInEnglish } from "./Revenues";

export const IncomeHistoryModal = (props: {
  open: boolean;
  setOpen: (open: boolean) => void;
}) => {
  const { open, setOpen } = props;
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { id: trainerId } = useParams<{ id: string }>();

  const [pagination, setPagination] = useState<PaginationType>({
    page: 0,
    limit: PAGE_SIZE,
    skip: 0,
  });
  const { revenues, loading, metadata } = useAppSelector(
    (state) => state.dashboardRevenues
  );

  useEffect(() => {
    dispatch(getRevenuesStart({ trainerId, pagination }));
  }, [pagination, dispatch, trainerId, open]);

  useEffect(() => {
    return () => {
      dispatch(resetIncomeHistory());
    };
  }, []);

  const handleCancel = () => {
    setOpen(false);
  };

  const columns = [
    {
      title: t("Date"),
      dataIndex: "createdAt",
      key: "createdAt",
      render: (date: string) => {
        const parsedDate = new Date(date);
        const month = t(monthsInEnglish[parsedDate.getMonth()]);
        const year = parsedDate.getFullYear().toString().slice(-2);
        return <>{`${month} ${year}׳`}</>;
      },
    },
    {
      title: t("Amount to Pay"),
      dataIndex: "revenue",
      key: "revenue",
      width: 150,
      render: (revenue: number, obj: any) => (
        <>
          {formatNumber(revenue)} {getCurrencySymbol(obj.currency)}
        </>
      ),
    },
    // {
    //   title: t("Status"),
    //   dataIndex: "status",
    //   key: "status",
    // }
  ];

  const onPaginationChange = (page: number) => {
    setPagination({ ...pagination, page, skip: PAGE_SIZE * (page - 1) });
  };

  return (
    <>
      <StyledIncomeHistoryModal
        title={t("Income History")}
        open={open}
        footer={[
          <Button type="primary" key="back" onClick={handleCancel}>
            {t("Close")}
          </Button>,
        ]}
        onCancel={handleCancel}
        centered
        width={650}
      >
        <Spin spinning={loading}>
          <StyledTable
            columns={columns}
            dataSource={revenues}
            pagination={false}
            locale={{ emptyText: t("No results") }}
            rowKey="_id"
          />
          <Pagination
            current={metadata?.page}
            pageSize={PAGE_SIZE}
            total={metadata?.total}
            align="center"
            hideOnSinglePage
            onChange={onPaginationChange}
            showSizeChanger={false}
            style={{ direction: "ltr", marginTop: "60px" }}
          />
        </Spin>
      </StyledIncomeHistoryModal>
    </>
  );
};
